import { useRef, useCallback } from "react";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, LinearScale, Filler, Tooltip, Legend } from "chart.js";
import { Radar } from "react-chartjs-2";

ChartJS.register(PointElement, RadialLinearScale, LineElement, LinearScale, Filler, Tooltip, Legend);
// ChartJS.defaults.scale.ticks.display = false;
ChartJS.defaults.maintainAspectRatio = false;
ChartJS.defaults.responsive = true;

const data = (traits) => ({
	labels: traits.map((trait) => trait.name),
	datasets: [
		{
			label: "Student Performance Distribution",
			data: traits.map((trait) => trait.performance),
			backgroundColor: "#4e81bd",
			borderColor: "#4e81bd",
			borderWidth: 1,
			pointBackgroundColor: "transparent",
			pointBorderColor: "transparent",
			clip: 0,
		},
	],
});

const RadarChart = ({ traits, setChart }) => {
	const chartRef = useRef(null);

	const runTillRendered = useCallback(() => {
		if (!chartRef.current) return runTillRendered();
		setChart(chartRef.current.toBase64Image());
	}, []);

	const options = {
		scales: {
			r: {
				max: 5,
				stepSize: 1,
				min: 0,
			},
		},
		scale: {
			ticks: { display: false },
		},
		plugins: {
			legend: {
				display: false,
			},
		},
		responsive: true,
		maintainAspectRatio: false,
		animation: {
			duration: 50,
			onComplete: () => {
				runTillRendered();
			},
		},
	};

	return (
		<div style={{ width: 500, height: 400 }}>
			<Radar data={data(traits)} options={options} ref={chartRef} />
		</div>
	);
};

export default RadarChart;
